import React from "react";
import Link from "theme/components/atoms/Typography/Link";
import Image from "theme/components/atoms/Image";
import AutocompleteItem from "theme/components/organisms/Autocomplete/AutocompleteItem/AutocompleteItem";

const PageResultItem = ({ result }) => {
  return (
    <AutocompleteItem
      image={
        result.seoImages.length > 0 && (
          <Image
            src={result.seoImages.shift().path}
            alt={result.title}
            format="thumbnail"
            appearance="full"
          />
        )
      }
      name={
        <Link key={result.identifier} to={result.path} clickType="block">
          {result.title}
        </Link>
      }
    />
  );
};

export default PageResultItem;
